import React, { useState, useEffect, useRef } from "react";
import { Modal, Form, Input, Button, notification, Select } from "antd";
import { BASE_URL, callApi } from "../../api/apiCaller";
import { GreenNotify, RedNotify } from "../../helper/helper";
import routes from "../../api/routes";

import configureAppStore from "../../redux/store";

const AddCategory = ({
  visible,
  item,
  toggleModal,
  recordData,
  addProduct,
  setAddProduct,
}) => {
  const [form] = Form.useForm();
  const [isloading, setIsLoading] = useState(false);
  const [image, setImage] = useState(null);
  const [fileError, setFileError] = useState("");
  const fileInputRef = useRef(null);
  const { Option } = Select;
  const dummyImage =
    "https://novathreadbucket.s3.amazonaws.com/nova-app-1685176470232-dummy.PNG";
  useEffect(() => {
    if (visible && recordData) {
      form.setFieldsValue({
        name: recordData?.name,
      });
      //setImage(recordData.image || dummyImage);
    }
  }, [visible, recordData, form]);

  const pickImageFile = () => {
    fileInputRef.current.click();
  };

  const token = configureAppStore.getState().userDataSlice.token;
  const uploadImageOnS3 = async (file) => {
    const myHeaders = new Headers();
    const formData = new FormData();
    formData.append("file", file);
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Authorization", token);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formData,
      redirect: "follow",
    };
    return await new Promise((resolve, reject) => {
      fetch(`${BASE_URL}/uploadImage`, requestOptions)
        .then((response) => response.json())
        .then((result) => resolve(result?.url))
        .catch((error) => reject(error));
    });
  };

  const handleFileChange = (event) => {
    const fileList = event.target.files;

    if (fileList.length > 0) {
      const file = fileList[0];

      const reader = new FileReader();
      reader.onloadend = async () => {
        const thubnailUrl = await uploadImageOnS3(file);
        setImage(thubnailUrl);
        setFileError("");
      };
      reader.readAsDataURL(file);
    } else {
      setFileError("Please select a file.");
    }
  };

  const handleSave = () => {
    form
      .validateFields()
      .then((values) => {
        const requestBody = {
          ...values,
          // img: image,
        };
        callApi(
          "POST",
          `${routes.createContactUs}`,
          requestBody,
          setIsLoading,
          (res) => {
            if (res.status === 409) {
              RedNotify(
                "Contact Us already exists you cannot create more than one."
              );
            } else if (res.status === 200) {
              GreenNotify("Contact Us Created Successfully");
              toggleModal();
            } else {
              RedNotify("Error Occurred. Please try again later.");
            }
          },
          (error) => {
            console.error("API Call Error:", error);
            RedNotify(
              "An error occurred during the API call. Please try again later.",
              error
            );
          }
        );
      })
      .catch((errorInfo) => {
        console.error("Validation Error:", errorInfo);
      });
  };

  return (
    <Modal
      title={"Create Contact Us"}
      visible={visible}
      onCancel={toggleModal}
      footer={[
        <Button key="cancel" onClick={toggleModal}>
          Cancel
        </Button>,
        <Button key="save" type="primary" onClick={handleSave}>
          Save
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="Text"
          name="text"
          rules={[
            {
              required: true,
              message: "Please enter the text",
            },
          ]}
        >
          <Input.TextArea autoSize={{ minRows: 2, maxRows: 6 }} />
        </Form.Item>
        <Form.Item
          label="Phone"
          name="phone"
          rules={[
            {
              required: true,
              message: "Please enter the phone",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Email"
          name="email"
          rules={[
            {
              required: true,
              message: "Please enter the email",
            },
          ]}
        >
          <Input />
        </Form.Item>

        {/* <div
          onClick={pickImageFile}
          style={{ marginBottom: "2rem" }}
          className="add-product-modal-input-title"
        >
          <h2> Image</h2>
          <div className="add-product-modal-image">
            <img src={image ? image : dummyImage} alt="" />
          </div>
          <input
            type="file"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileChange}
            required
          />
          {fileError && <p style={{ color: "red" }}>{fileError}</p>}
        </div> */}
      </Form>
    </Modal>
  );
};

export default AddCategory;
